import React from 'react';
import { Upload, Loader, Check, AlertCircle } from 'lucide-react';

const FileStatusBadge = ({ status }) => {
  const statusConfig = {
    uploading: {
      icon: <Upload className="animate-pulse" size={14} />,
      text: "Загрузка...",
      color: "text-blue-400",
      bgColor: "bg-blue-500/10"
    },
    processing: {
      icon: <Loader className="animate-spin" size={14} />,
      text: "Обработка...",
      color: "text-orange-400",
      bgColor: "bg-orange-500/10"
    },
    ready: {
      icon: <Check size={14} />,
      text: "Готов",
      color: "text-green-400",
      bgColor: "bg-green-500/10"
    },
    error: {
      icon: <AlertCircle size={14} />,
      text: "Ошибка",
      color: "text-red-400",
      bgColor: "bg-red-500/10"
    }
  };

  const config = statusConfig[status] || statusConfig.ready;

  // Don't show badge if status is ready (default)
  if (status === 'ready') {
    return null;
  }

  return (
    <div className={`flex items-center space-x-1 px-2 py-0.5 rounded-full ${config.color} ${config.bgColor}`}>
      {config.icon}
      <span className="text-xs font-medium">{config.text}</span>
    </div>
  );
};

export default FileStatusBadge;
